<template>
    <div class="bg-gray-100">
        <TopLocationHero title-key="ethnography.title" static-image-key="ethnography___hero" />

        <div class="relative mt-4 sm:mt-12 z-1">
            <a id="main-content" class="fixed top-0" tabindex="-1"></a>

            <div class="container hidden sm:block">
                <Breadcrumb :items="breadcrumbItems" />
            </div>

            <TopLocationBackgroundShape1 />
        </div>

        <div class="relative mt-10 z-2">
            <div class="container">
                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- INTRO -->
                <!-- * -->
                <Type1Block
                    title-key="ethnography.intro.title"
                    description-key="ethnography.intro.description"
                    :img="require('assets/images/illustrations/buildings/museum-of-ethnography.svg')"
                    building-name-key="ethnography.intro.building_name"
                    building-area-key="ethnography.intro.building_area"
                    building-architect-key="ethnography.intro.building_architect"
                    building-contractor-key="ethnography.intro.building_contractor"
                />

                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- DID YOU KNOW? -->
                <!-- * -->
                <Type9Block
                    title-key="ethnography.did_you_know.title"
                    description-key="ethnography.did_you_know.description"
                    img-orientation-portrait
                    class="mt-16 sm:mt-20"
                    static-image-key="ethnography___did-you-know"
                />

                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- LOCATION GUIDE -->
                <!-- * -->
                <Type3Block
                    title-key="ethnography.location.title"
                    description-key="ethnography.location.description"
                    class="mt-16 sm:mt-20"
                    static-image-key="ethnography___location-guide"
                />
            </div>
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- FIRST ROOF GARDEN OF BUDAPEST -->
        <!-- * -->
        <div v-if="galleryImages1" class="relative z-2 mt-16 sm:mt-20">
            <Type2Block
                title-key="ethnography.roof_garden.title"
                description-key="ethnography.roof_garden.description"
                :images="galleryImages1"
            />
        </div>

        <div class="relative z-1 mt-16 sm:mt-20">
            <div class="container relative z-2">
                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- MAIN ENTRANCE -->
                <!-- * -->
                <Type6Block
                    title-key="ethnography.entrance.title"
                    description-key="ethnography.entrance.description"
                    class="z-1"
                    :images="galleryImages4"
                />
            </div>
            <TopLocationBackgroundShape4 flip-y flip-x class="-bottom-24 sm:-bottom-24 md:-bottom-28 lg:-bottom-32" />
        </div>

        <div class="container relative z-2 mt-16 sm:mt-20">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- THE EXHIBITION -->
            <!-- * -->
            <Type8Block title-key="ethnography.exhibition.title" description-key="ethnography.exhibition.description" />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- MOSAIQUE GALLERY -->
            <!-- * -->
            <MosaiqueGalleryBlock v-if="galleryImages2" :items="galleryImages2" class="mt-16 sm:mt-20" />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- HOW WAS IT COMPLETED? -->
            <!-- * -->
            <Type8Block
                title-key="ethnography.completion.title"
                description-key="ethnography.completion.description"
                class="mt-16 sm:mt-20"
            />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- ENTRANCE FROM THE UNDERGROUND GARAGE -->
            <!-- * -->
            <Type8Block
                title-key="ethnography.entrance_from_underground.title"
                description-key="ethnography.entrance_from_underground.description"
                class="mt-16 sm:mt-20"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- GALLERY -->
        <!-- * -->
        <XXLGalleryCarousel v-if="galleryImages3" :images="galleryImages3" class="mt-16 sm:mt-20" />

        <div class="container relative z-2 mt-16 sm:mt-20">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- A BIT OF HISTORY -->
            <!-- * -->
            <Type9Block
                title-key="ethnography.history.title"
                description-key="ethnography.history.description"
                static-image-key="ethnography___history"
            />
        </div>

        <div class="container mt-16 sm:mt-20">
            <TopLocationProjectPageBanner
                v-if="$t('ethnography.event_recommendation_button_url').length"
                :button-text="$t('ethnography.event_recommendation_button_label')"
                :button-url="$t('ethnography.event_recommendation_button_url')"
                label-text-key="ethnography.event_recommendation_text"
                type="event"
            />

            <TopLocationProjectPageBanner
                :button-text="$t('ethnography.visit_project_button_label')"
                :button-url="$t('ethnography.visit_project_button_url')"
                label-text-key="ethnography.visit_project_text"
                class="mt-4 sm:mt-8"
            />

            <AwardsBlock
                v-if="awards"
                :title="awards.title"
                :description="awards.description"
                :media="awards.media"
                class="mt-16 sm:mt-20"
            />
        </div>
    </div>
</template>

<script>
import TopLocationProjectPageBanner from '@/components/Pages/TopLocation/TopLocationProjectPageBanner.vue';
import AwardsBlock from '@/components/Blocks/AwardsBlock/AwardsBlock.vue';
import TopLocationHero from '@/components/Pages/TopLocation/Hero/Hero.vue';
import Type3Block from '@/components/Blocks/Type3Block/Type3Block.vue';
import Type6Block from '@/components/Blocks/Type6Block/Type6Block.vue';
import TopLocationBackgroundShape1 from '@/components/Pages/TopLocation/TopLocationBackgroundShape1.vue';
import Type1Block from '@/components/Blocks/Type1Block/Type1Block.vue';
import Type9Block from '@/components/Blocks/Type9Block/Type9Block.vue';
import Type2Block from '@/components/Blocks/Type2Block/Type2Block.vue';
import Type8Block from '@/components/Blocks/Type8Block/Type8Block.vue';
import MosaiqueGalleryBlock from '@/components/Blocks/MosaiqueGalleryBlock/MosaiqueGalleryBlock.vue';
import XXLGalleryCarousel from '@/components/Carousels/XXLGalleryCarousel/XXLGalleryCarousel.vue';
import TopLocationBackgroundShape4 from '@/components/Pages/TopLocation/TopLocationBackgroundShape4.vue';

export default {
    name: 'MuseumOfEthnography',
    components: {
        AwardsBlock,
        TopLocationProjectPageBanner,
        TopLocationBackgroundShape4,
        XXLGalleryCarousel,
        MosaiqueGalleryBlock,
        Type8Block,
        Type2Block,
        Type9Block,
        Type1Block,
        TopLocationBackgroundShape1,
        TopLocationHero,
        Type3Block,
        Type6Block,
    },
    async asyncData({ $axios, i18n }) {
        let galleryImages1 = null;
        let galleryImages2 = null;
        let galleryImages3 = null;
        let galleryImages4 = null;
        let awards = null;

        await Promise.allSettled([
            $axios.$get('/galleries/reference/top-location___ethnography-1'),
            $axios.$get('/galleries/reference/top-location___ethnography-2'),
            $axios.$get('/galleries/reference/top-location___ethnography-3'),
            $axios.$get('/galleries/reference/top-location___ethnography-4'),
            $axios.$get('/awards/reference/ethnography'),
        ])
            .then(([galleryImages1Res, galleryImages2Res, galleryImages3Res, galleryImages4Res, awardsRes]) => {
                if (galleryImages1Res.status === 'fulfilled') {
                    galleryImages1 = galleryImages1Res.value.slides;
                }

                if (galleryImages2Res.status === 'fulfilled') {
                    galleryImages2 = galleryImages2Res.value.slides;
                }

                if (galleryImages3Res.status === 'fulfilled') {
                    galleryImages3 = galleryImages3Res.value.slides;
                }

                if (galleryImages4Res.status === 'fulfilled') {
                    galleryImages4 = galleryImages4Res.value.slides;
                }

                if (awardsRes.status === 'fulfilled' && awardsRes.value.is_on_top_locations) {
                    awards = awardsRes.value;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('navigation.top_locations'), 'top-locations', true]);
        breadcrumbItems.push([i18n.t('ethnography.title'), 'museum-of-ethnography']);

        return {
            galleryImages1,
            galleryImages2,
            galleryImages3,
            galleryImages4,
            awards,
            breadcrumbItems,
        };
    },
    data() {
        return {};
    },
    head() {
        return {
            title: this.$getPageTitle('top-locations.museum-of-ethnography'),
            meta: this.$getPageMetaData('top-locations.museum-of-ethnography'),
        };
    },
};
</script>

<style scoped></style>
